import { EntityDetail } from '../../entityFramework/entityDetail/EntityDetail'
import { EntityPropForm } from './EntityPropForm'

export const EntityPropDetail = () => {

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityPropForm /> },
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}